import { useAppDispatch } from '../../../../hooks/redux';
import { IAcc } from '../../../../models/IProfile';
import { returnTasks } from '../../../../service/TasksService';
import { setErrorApp } from '../../../../store/reducers/InfoSlice';
import { setAcc, setConfirmModal, setId } from '../../../../store/reducers/ModalSlice';
import { TYPE_SERVICE } from '../../../../utils/const';
import { Icon } from '../../../Icon';
import styles from './sipAccountList.module.css';

type Props = {
	accs: IAcc[];
	handleOpenAddNewSip: (item: IAcc) => void;
}

export function SipAccountList({ accs, handleOpenAddNewSip }: Props): JSX.Element {
	const dispatch = useAppDispatch();

	const checkTask = async (textError: string) => {
		const userTasks = await returnTasks();
		if (userTasks.error) {
			return dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при проверке запущенных задач',
				})
			);
		} else {
			const { data } = userTasks.data.data;
			if (data.length > 0) {
				for (const itemTask of data) {
					if (itemTask.nameFile.includes(TYPE_SERVICE)) {
						return dispatch(
							setErrorApp({
								isErrorApp: true,
								errorApp: textError,
							})
						);
					}
				}
			}
		}
	};

	const handleEdit = async (item: IAcc) => {
		const task_for_edit = await checkTask(
			'Для изменения дополнительного аккаунта, необходимо выключить прием показаний счетчиков'
		);
		if (task_for_edit) return;
		handleOpenAddNewSip(item)
	};

	const showModal = async (id: string) => {
		const task = await checkTask(
			'Для удаления дополнительного аккаунта, необходимо выключить прием показаний счетчиков'
		);
		if (task) return;
		dispatch(
			setConfirmModal({
				show: true,
			}),
		);
		dispatch(setId(id));
		dispatch(setAcc(accs));
	}
	return (
		<div className={styles.sipAccountList}>
			<ul>
				{accs.map((item) => (
					<div key={item.id} className={styles.sipElement}>
						<li>
							<div className={styles.sip_list}>
								<div className={styles.phone_getter}>
									{item.phone}@
									{item.server_sip}
								</div>
								<div className={styles.sip_list}>
									<span className={styles.sip_list_icons} onClick={() => handleEdit(item)}>
										<Icon name={'edit'} size={20} />
									</span>
									<span onClick={() => showModal(item.id)}>
										<Icon name={'delete'} size={20} />
									</span>
								</div>
							</div>
						</li>
					</div>
				))
				}
			</ul >
		</div >
	);
}

